export type AvailabilityConfig = {
  initialResultSetSize: number;
  showMoreAmount: number;
  desktopOffsetScroll: number;
  mobileOffsetScroll: number;
};

export const defaultAvailabilityConfig: AvailabilityConfig = {
  initialResultSetSize: 20,
  showMoreAmount: 20,
  desktopOffsetScroll: 150,
  mobileOffsetScroll: 150,
};
